import React from 'react'

//import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    nvl,
} from '../../../business-components/Formata/Formata'

import {
    GridContainer,
    GridItem12,
 } from '../../../business-components/Grid/Grid'

 import {
    CardGridEstudo,
    CardGridDivHeaderDestaque1,
    CardGridDivH4Destaque,
    CardGridDivBody,
} from '../../../business-components/Card/Card'

//import {
//    RichTextEditorViewer
//} from '../../../business-components/RichTextEditor/RichTextEditorViewer'

import {
    RichTextEditorViewerPadrao
} from '../../../business-components/RichTextEditor/RichTextEditorViewerPadrao'

import {
    relatorioModoApresentacao,
} from './EstudoService'

import {
    GridContainerEstudoPadraoLg,
} from './EstudoComp'



const EstudoFormConsideracoesFinais = ( { values, linhaFormList, report, indPagina } ) => {

    return (
        <GridItem12
            align='left'
        >
            {report || relatorioModoApresentacao(values)
                ?
                    //<div
                    //    className={/*'mt-0' + */(relatorioModoApresentacao(values) ? ' mt-5 mr-20' : '')} // mudança da fonte: mt-2
                    //>
                        /*
                        <RichTextEditorViewer
                            content={values.consideracaoFinal[indPagina]}
                        />
                        */
                        <RichTextEditorViewerPadrao
                            content={values.consideracaoFinal[indPagina].richText}
                        />
                    //</GridItem12></div>
                :
                    <GridContainerEstudoPadraoLg
                        component={
                            <CardGridEstudo>
                                <CardGridDivHeaderDestaque1>
                                    <GridContainer>
                                        <GridItem12>
                                            <CardGridDivH4Destaque>
                                                {/*linhaFormList.labelTabClienteFormListConsideracoesFinais*/
                                                    nvl(values.consideracaoFinal[indPagina].tituloPagina,
                                                        linhaFormList.labelTabClienteFormListConsideracoesFinais
                                                    )
                                                }
                                            </CardGridDivH4Destaque>
                                        </GridItem12>
                                    </GridContainer>
                                </CardGridDivHeaderDestaque1>

                                {//values.consideracaoFinal?.map((item, ind) => {

                                   // return item.richText && item.richText !== HARDCODE.richTextEditorVazio ? (
                                        <CardGridDivBody
                                            //key={ind}
                                        >
                                            <GridItem12
                                                className='ml-2'
                                            >
                                                {/*
                                                <RichTextEditorViewer
                                                    content={item}
                                                />
                                                */}
                                                <RichTextEditorViewerPadrao
                                                    //content={item.richText}
                                                    content={values.consideracaoFinal[indPagina].richText}
                                                />
                                            </GridItem12>
                                        </CardGridDivBody>
                                    //)
                                    //:
                                    //(
                                    //    ''
                                    //)
                                //})
                                }
                            </CardGridEstudo>
                        }
                    />
            }
        </GridItem12>
    )
}

export default EstudoFormConsideracoesFinais